import {connect} from 'react-redux';
import {getFilteredLocations,getLocations,resetMeta,resetPage} from '../../actions/LocationListPage';
import LocationListPage from './LocationListPage';


const mapsStateToProps = state =>({
	LocationListPageProps: state.locationListPageReducer,
	drawerReducer: state.drawerReducer
});

const mapsDispatchToProps = dispatch =>({
	getFilteredLocations(options) {
        		dispatch(getFilteredLocations(options));
        	},
	getLocations(options){
		dispatch(getLocations(options));
	},
	resetMeta(){
		dispatch(resetMeta());
	},
	resetPage(){
		dispatch(resetPage());
	}

});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps)(LocationListPage);
